<template>
  <div class="delay-block">
    <h3 class="delay-block__title">{{ $t('view.flow.block.delay.title') }}</h3>
    <div class="delay-block__time-row">
      <in
        class="delay-block__input delay-block__input-time"
        type="number"
        v-model="val.time"
        :max="timeLimit"
        :label="$t('view.flow.block.delay.time')"
        @input="onInput"
      ></in>
      <sel
        class="delay-block__input delay-block__input-unit"
        v-model="val.timeUnit"
        :label="$t('view.flow.block.delay.timeUnit')"
        @input="onInput"
      >
        <option value="h">{{ $t('view.flow.block.delay.hours') }}</option>
        <option value="m">{{ $t('view.flow.block.delay.minutes') }}</option>
      </sel>
      <sel
        class="delay-block__input delay-block__mode"
        v-model="val.from"
        :label="$t('view.flow.block.delay.mode')"
        @input="onInput"
      >
        <option :value="1">{{ $t('view.flow.block.delay.now') }}</option>
        <option :value="2">{{ $t('view.flow.block.delay.lastActive') }}</option>
      </sel>
    </div>
    <in
      class="delay-block__input"
      v-model="val.name"
      :max="timeLimit"
      :label="$t('view.flow.block.delayCancel.name')"
      @input="onInput"
    ></in>
    <sel
      class="delay-block__input"
      v-model="val.block"
      :label="$t('view.flow.block.delay.block')"
      @input="onInput"
    >
      <optgroup v-for="group in this.$store.state.flowGroups" :key="group.id" :label="group.name">
        <option v-for="block in group.blocks" :key="block.id" :value="block.uuid">{{ block.name }}</option>
      </optgroup>
    </sel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  },
  computed: {
    timeLimit () {
      return this.val.timeUnit === 'h' ? 24 : 60
    }
  }
}
</script>

<style lang="scss" scoped>
.delay-block {
  @include flowElementShadow();
  width: 30%;
  min-width: 380px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;

  &__input {
    margin-bottom: 6px;
  }

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__time-row {
    display: flex;
    align-items: baseline;
    margin-bottom: 10px;
  }

  &__input-time {
    width: 75px;
    margin-right: 10px;
  }

  &__input-unit {
    width: 160px;
  }

  &__mode {
    margin-left: 10px;
  }
}
</style>
